const { getDateInIso } = require('../../utils/Dates');

const MS_PER_DAY = 1000 * 60 * 60 * 24;

const POINTS_TOGGLE_STATE = {
    ON: 'on',
    OFF: 'off'
};

const SELECTED_OPTION = {
    LOGIN: 'login',
    REGISTER: 'register'
};

const getPointsToggleState = (showPricesInPoints) => {
    return showPricesInPoints ? POINTS_TOGGLE_STATE.ON : POINTS_TOGGLE_STATE.OFF;
};

const getLoyaltyMemberObject = (isLoyaltyMember, pointsBalance) => {
    return {
        is_loyalty_member: !!isLoyaltyMember,
        ...(isLoyaltyMember && typeof pointsBalance === 'number' && { points_balance: pointsBalance })
    };
};

const getNights = (checkIn, checkOut) => {
    if (!checkIn || !checkOut) {
        return;
    }

    const checkInDate = new Date(checkIn);
    const checkOutDate = new Date(checkOut);

    if (isNaN(checkInDate.getTime()) || isNaN(checkOutDate.getTime())) {
        return;
    }

    const nights = Math.round((checkOutDate - checkInDate) / MS_PER_DAY);

    return nights > 0 ? nights : undefined;
};

const getPartnerSearchObject = (searchDestination, search) => {
    if (!search) {
        return {};
    }

    const guests = search && (search.guests || search.guest_count);
    const rooms = search && (search.rooms || search.room_count);
    const nights = getNights(search.check_in, search.check_out);

    return {
        ...(searchDestination && { search_destination: searchDestination }),
        ...(search && search.check_in && { search_checkin_date: getDateInIso(search.check_in) }),
        ...(search && search.check_out && { search_checkout_date: getDateInIso(search.check_out) }),
        ...(nights && { search_nights: nights }),
        ...(guests && { search_guests_adults: guests }),
        ...(rooms && { search_rooms: rooms })
    };
};

module.exports = {
    POINTS_TOGGLE_STATE,
    SELECTED_OPTION,
    getPointsToggleState,
    getLoyaltyMemberObject,
    getPartnerSearchObject
};
